import _reduxForm from "redux-form/es/reduxForm";
import React from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import cn from 'classnames';
import { ReduxFormNames } from 'swag-client-common/constants';
import CongratsView from './congrats-view';
import ResetPassForm from './reset-form';
import classes from './set-password-form.scss';
const animationClasses = {
  enter: classes.enter,
  enterActive: classes.enterActive,
  exit: classes.exit,
  exitActive: classes.exitActive
};
function SetPasswordForm({
  errorMessage,
  handleSubmit,
  onSubmit,
  mode,
  isError,
  isLoading,
  requireApproveTerms,
  invalid,
  isSuccess,
  password,
  completedPasswordRequirements,
  isAllPasswordRequirementsCompleted,
  isPasswordLengthMoreThanMaxAllowedCharacters,
  isPasswordInputFocused,
  onClose
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: cn(classes.container, {
      [classes.isSuccess]: isSuccess,
      [classes.isForm]: !isSuccess
    })
  }, /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: animationClasses,
    key: String(isSuccess),
    timeout: 300
  }, isSuccess ? /*#__PURE__*/React.createElement(CongratsView, {
    onClose: onClose
  }) : /*#__PURE__*/React.createElement(ResetPassForm, {
    errorMessage: errorMessage,
    handleSubmit: handleSubmit,
    onSubmit: onSubmit,
    mode: mode,
    isError: isError,
    isLoading: isLoading,
    requireApproveTerms: requireApproveTerms,
    password: password,
    completedPasswordRequirements: completedPasswordRequirements,
    isAllPasswordRequirementsCompleted: isAllPasswordRequirementsCompleted,
    isPasswordLengthMoreThanMaxAllowedCharacters: isPasswordLengthMoreThanMaxAllowedCharacters,
    isPasswordInputFocused: isPasswordInputFocused,
    invalid: invalid
  }))));
}
export default _reduxForm({
  form: ReduxFormNames.SetPasswordFromPageForm
})(SetPasswordForm);